import { fetchBookingSettingReducer } from './fetchBookingSetting.thunk';
import { fetchReservationsReducer } from './fetchReservations.thunk';
import { fetchReservationsSilentReducer } from './fetchReservationsSlient.thunk';

export const bookingThunkReducers = {
  ...fetchReservationsReducer,
  ...fetchReservationsSilentReducer,
  ...fetchBookingSettingReducer,
};
